var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-preview",style:({
      backgroundColor: _vm.panelDesign.backgroundColor,
      borderColor: _vm.panelDesign.borderColor,
      borderWidth: `${_vm.panelDesign.borderSize}px`,
      borderRadius: `${_vm.panelDesign.borderRadius}px`,
  })},[_c('div',{staticClass:"c-preview__title",style:({
          color: _vm.panelDesign.textColor,
      })},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"c-preview__amount",style:({
          color: _vm.panelDesign.amountColor,
      })},[_vm._v(" $"+_vm._s(_vm.amountCurrency)+" ")]),_c('div',{staticClass:"c-preview__description",style:({
              color: _vm.panelDesign.textColor,
          })},[_vm._v(" "+_vm._s(_vm.description)+" ")]),(_vm.buttonLabel)?_c('button',{staticClass:"btn c-preview__btn",style:({
              backgroundColor: _vm.buttonDesign.color,
              color: _vm.buttonDesign.textColor,
              borderColor: _vm.buttonDesign.borderColor,
              borderWidth: `${_vm.buttonDesign.borderSize}px`,
              borderRadius: `${_vm.buttonDesign.borderRadius}px`,
          }),on:{"click":_vm.donate}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }